module.exports = __webpack_public_path__ + "img/picto-piece.53b742da.svg";